import { useState } from "react";
import locale from "@bonliva-crm/locale";
import { useSnackbarsPipeline } from "@bonliva-crm/ui";
import { store } from "@store";
import { ORDER_SLIDER, OrderCreateLocation } from "@navigation";
import {
  ConsultantQualityCheckConsultantDataFragment,
  ConsultantQualityCheckDataFragment,
  ConsultantQuality_ConsultantNewFragment
} from "@bonliva-crm/graphql";
import { OrderCreateData } from "@orders/order-create/order-create-data";
import { OrderCreatePageProps } from "@orders/order-create/order-create-page";

export type UseRequestOrderParams = {
  data: ConsultantQualityCheckDataFragment;
  consultantData:
    | ConsultantQuality_ConsultantNewFragment
    | ConsultantQualityCheckConsultantDataFragment;
  requestFn: (values: any) => Promise<unknown>;
  oldDesign?: boolean;
  orderOptions?: OrderCreatePageProps["options"];
};

export function useRequestOrder({
  data,
  consultantData,
  requestFn,
  oldDesign = false,
  orderOptions = {}
}: UseRequestOrderParams) {
  const [loading, setLoading] = useState(false);
  const [ordered, setOrdered] = useState(false);
  const snackbar = useSnackbarsPipeline({ old: oldDesign });

  const setRequestOrder = () => {
    return new Promise((resolve, reject) => {
      const orderCreateData = OrderCreateData.ByQualificationName(
        consultantData,
        data.Name
      );

      store().navigation.open(
        ORDER_SLIDER,
        new OrderCreateLocation({
          itemName: data.Name,
          initialValues: orderCreateData,
          onSubmit: (values) => {
            return requestFn(values).then(() => {
              setOrdered(true);
              snackbar.showSuccess(locale.Ordered);

              resolve(null);
            }, reject);
          },
          onCancel: () => resolve(null),
          options: orderOptions
        })
      );

      store().navigation.on("close", ORDER_SLIDER, () => {
        resolve(null);
      });
    });
  };

  const onRequestOrder = () => {
    setLoading(true);

    setRequestOrder()
      .catch((e) => {
        if (e === "order_cancel") {
          return;
        }

        console.error(e);
        snackbar.showError(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { loading, ordered, onRequestOrder };
}
